/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Calendar_Event_CountInputs */

const en_calendar_event_count = /** @type {(inputs: Calendar_Event_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events`)
};

const pt_br2_calendar_event_count = /** @type {(inputs: Calendar_Event_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} eventos`)
};

/**
* | output |
* | --- |
* | "{count} events" |
*
* @param {Calendar_Event_CountInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const calendar_event_count = /** @type {((inputs: Calendar_Event_CountInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Event_CountInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_event_count(inputs)
	return pt_br2_calendar_event_count(inputs)
});